import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';
import SocialIcons, {
	ISocialIconsProps,
} from 'tbk-components/src/components/SocialIcons';

export interface IFooterProps extends IBaseElementProps {
	logo?: IImage;
	homeLink?: ILink;
	menuPrimary?: NavItem[];
	menuSecondary?: NavItem[];
	calloutButtons?: ILink[];
	newsletterSignupHeading?: string;
	newsletterSignupTagline?: string;
	children?: any;
	address?: string;
	copyrightText?: string;
	socialIcons?: ISocialIconsProps;
}

/**
 * Footer
 * @block
 * @requiresHooks
 * @icon layout
 */
const Footer: React.FC<IFooterProps> = ({
	className,
	classNames = [],
	logo,
	homeLink,
	menuPrimary,
	menuSecondary,
	calloutButtons,
	newsletterSignupHeading,
	newsletterSignupTagline,
	children,
	address,
	copyrightText,
	socialIcons,
}) => {
	return (
		<footer className={className || cn('footer', ...classNames)}>
			<div className="container-fluid">
				<div className="row">
					<div className="footer__top">
						{menuPrimary.length > 0 && (
							<div className="footer__top-left">
								<Nav
									navItems={menuPrimary}
									collapseEnabled={true}
									dropdownEnabled={false}
									classNames={['footer__menu-primary']}
								/>
							</div>
						)}
						<div className="footer__top-right">
							{calloutButtons.length > 0 && (
								<div className="footer__callout-buttons">
									{calloutButtons.map((button, index) => (
										<Button
											key={index}
											classNames={[
												'footer__callout-button',
											]}
											{...button}
										/>
									))}
								</div>
							)}
							<div className="footer__newsletter-signup">
								{newsletterSignupHeading && (
									<h3 className="footer__newsletter-signup-heading">
										{newsletterSignupHeading}
									</h3>
								)}
								{newsletterSignupTagline && (
									<p className="footer__newsletter-signup-tagline">
										{newsletterSignupTagline}
									</p>
								)}
								{children}
							</div>
						</div>
					</div>
					<div className="footer__middle">
						{logo && (
							<div className="footer__logo">
								<Image {...logo} />
							</div>
						)}
						{address && (
							<address
								className="footer__address"
								dangerouslySetInnerHTML={{ __html: address }}
							/>
						)}

						{socialIcons && (
							<div className="footer__social">
								<SocialIcons {...socialIcons} />
							</div>
						)}
					</div>
					<div className="footer__seperator"></div>
					<div className="footer__bottom">
						{copyrightText && (
							<div className="footer__copyright">
								<span className="footer__copyright-text">
									{copyrightText}
								</span>
								{menuSecondary?.length > 0 && (
									<Nav
										navItems={menuSecondary}
										className="nav justify-content-center"
									/>
								)}
							</div>
						)}
						<div className="footer__tbk-container">
							<a
								href="https://www.aodaonline.com"
								target="_blank"
								className="footer__aoda"
								rel="noreferrer"
							>
								Monitored By: <span>AODA Online</span>
							</a>
							<a
								href="https://tbkcreative.com/?ref=intercede"
								target="_blank"
								className="footer__tbk"
								rel="noreferrer"
							>
								Web Design &amp; Digital Marketing{' '}
								<span>tbk Creative</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
